<script>
  import { link } from 'svelte-routing'

  export let to
</script>

<li class='nav-item'>
  <a href={to} class='nav-link' use:link><slot /></a>
</li>
